import { cn } from '@/utils/cn';

export interface SkeletonProps {
  className?: string;
  /** Accessible name for the loading region. Already localized. */
  label?: string | undefined;
}

/**
 * Token-colored stand-in sized to match real content. The shimmer is a CSS animation, so the
 * reduced-motion reset in `global.css` disables it with no extra prop.
 *
 * Used for `resolving` and for the branded `Suspense` fallback — never a spinner for a screen-level
 * load, so the merchant's brand is in the first frame.
 */
export function Skeleton({ className, label }: SkeletonProps) {
  return (
    <div
      role={label === undefined ? 'presentation' : 'status'}
      aria-label={label}
      aria-busy={label === undefined ? undefined : true}
      className={cn(
        'bg-surface-muted rounded-md',
        'motion-safe:animate-pulse',
        className,
      )}
    />
  );
}
